function loadPenelitian(view) {
    return () => import( /* webpackChunkName: "pertukaranpel-[request]" */ `../../views/KampusMerdeka/Penelitian/${view}.vue`)
}

function loadGuidancePenelitian(view) {
  return () => import( /* webpackChunkName: "guidances-[request]" */ `../../views/KampusMerdeka/BimbinganPenelitian/${view}.vue`)
}

const route = [
    {
        path: '/kampus-merdeka/penelitian/kaprodi/outcame-type', 
        name: 'OutcameType', 
        meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
        },
      component: loadPenelitian('OutcameType') //menyesuaikan nama component
    },
    {
        path: '/kampus-merdeka/penelitian/dosen/registration', 
        name: 'RegistrationDosen', 
        meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
        },
      component: loadPenelitian('RegistrationDosen') //menyesuaikan nama component
    },
    {
      path: '/kampus-merdeka/penelitian/kaprodi/registrationdosen', 
      name: 'VerifyRegistrationDosen', 
      meta: {
      requiresAuth: true,
      roleVerif: false,
      role: []
      },
    component: loadPenelitian('VerifyRegistrationDosen') //menyesuaikan nama component
    },
    {
      path: '/kampus-merdeka/penelitian/mahasiswa/oprec', 
      name: 'OprecRegistration', 
      meta: {
      requiresAuth: true,
      roleVerif: false,
      role: []
      },
    component: loadPenelitian('OprecRegistration') //menyesuaikan nama component
    },
    //Hasil Seleksi Mahasiswa
    {
      path: '/kampus-merdeka/penelitian/mahasiswa/seleksi', 
      name: 'ResearchSelectionMahasiswa', 
      meta: {
      requiresAuth: true,
      roleVerif: false,
      role: []
      },
    component: loadPenelitian('ResearchSelectionMahasiswa') //menyesuaikan nama component
    },

    {
      path: '/kampus-merdeka/penelitian/dosen/seleksimahasiswa', 
      name: 'SelectionMahasiswa', 
      meta: {
      requiresAuth: true,
      roleVerif: false,
      role: []
      },
    component: loadPenelitian('SelectionMahasiswa') //menyesuaikan nama component
    },

    {
      path: '/penelitian-logbook/:id',
      name: 'LogbookPenelitian',
      meta: {
          requiresAuth: true,
          roleVerif: false,
          role: []
      },
      component: loadPenelitian('LogbookPenelitian')
    },
    //RegionRubric
    {
      path: '/research-rubric',
      name: 'RubricPenelitian',
      meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['kaprodi','sekprodi']
      },
      component: loadPenelitian('RubricCategory')
    },
    {
      path: '/research-rubric/:category_id',
      name: 'RubricFieldPenelitian',
      meta: {
          requiresAuth: true,
          roleVerif: true,
          role: ['kaprodi','sekprodi']
      },
      component: loadPenelitian('RubricField')
    },
  // Region Bimbingan

  {
    path: '/kampus-merdeka/dosen/bimbingan/penelitian/:student_id',
    name: 'MyStudentGuidancesResearch',
    meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['kaprodi','administrator','sekprodi','dosen', 'kalab', 'wadek', 'kadep']
    },
    component: loadGuidancePenelitian('ListBimbinganMahasiswa')
  },
  {
    path: '/kampus-merdeka/dosen/bimbingan/penelitian',
    name: 'MyGuidanceStudentsResearch',
    meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['kaprodi','administrator','sekprodi','dosen', 'kalab', 'wadek', 'kadep']
    },
    component: loadGuidancePenelitian('ListMahasiswaBimbingan')
  },
  {
    path: '/kampus-merdeka/dosen/bimbingan/penelitian/:student_id/:guidance_id',
    name: 'ResponseMyStudentGuidanceResearch',
    meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['kaprodi','administrator','sekprodi','dosen', 'kalab', 'wadek', 'kadep']
    },
    component: loadGuidancePenelitian('ResponseBimbinganMahasiswa')
  },
  {
    path: '/kampus-merdeka/mahasiswa/bimbingan/penelitian/:guidance_id',
    name: 'ResponseGuidanceResearch',
    meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['mahasiswa']
    },
    component: loadGuidancePenelitian('ResponseBimbinganMahasiswa')
  },
  {
    path: '/kampus-merdeka/mahasiswa/bimbingan/penelitian',
    name: 'ListBimbinganResearch',
    meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['mahasiswa']
    },
    component: loadGuidancePenelitian('ListBimbingan')
  },
  {
    path: '/kampus-merdeka/form/bimbingan/penelitian',
    name: 'FormBimbinganResearch',
    meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['mahasiswa']
    },
    component: loadGuidancePenelitian('FormBimbingan')
  },
  
  
  //Region Exam
  {
    path: '/research-exam/:detail_id',
    meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
    },
    component: loadPenelitian('MainViewExam'),
    children: [
        {
            path: '',
            name: 'Ujian Penelitian',
            component: loadPenelitian('ExamDetail')
        },
        {
            path: 'lecture',
            name: 'Penilaian Dosen Pembimbing Penelitian',
            component: loadPenelitian('LectureRubric')
        },
        {
            path: 'result',
            name: 'Nilai Penelitian',
            component: loadPenelitian('PenelitianResult')
        }
    ]
  },
  {
    path: '/research-exam',
    name: 'ResearchVerifyExam',
    meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['kaprodi','administrator','sekprodi','dosen', 'kalab', 'wadek', 'kadep']
    },
    component: loadPenelitian('VerifyExam')
  },
  
  //Region Konversi
  {
    path: '/konversi-research',
    name: 'StudentConvertionViewResearch',
    meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['kaprodi','administrator','sekprodi']
    },
    component: loadPenelitian('StudentConvertionView')
},
{
    path: '/konversi-research/mata-kuliah/:id',
    name: 'ConvertionViewResearch',
    meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['kaprodi','administrator','sekprodi']
    },
    component: loadPenelitian('ConvertionView')
},
{
    path: '/konversi-research/mata-kuliah/:id/TU',
    name: 'ConvertionViewResearchAdmin',
    meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['administrator', 'mahasiswa']
    },
    component: loadPenelitian('ConvertionViewAdmin')
},
    
]

export default route

